module.exports = __webpack_public_path__ + "static/media/tal-full-white.872b1609.svg";